module.exports = __webpack_public_path__ + "static/media/24.7a53dace.jpg";